import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { services } from '../mock';
import { useNavigate } from 'react-router-dom';

export const Services = () => {
  const navigate = useNavigate();
  
  const scrollToContact = (serviceId) => {
    // For commercial (id 4) and hazardous (id 6), go to contact form
    if (serviceId === 4 || serviceId === 6) {
      navigate('/calculator#contact-form');
    } else {
      navigate('/calculator');
    }
  };

  return (
    <section id="services" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our <span className="text-[#0B7CB5]">Cleaning Services</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Professional cleaning solutions tailored to your needs — from standard maintenance to specialized deep cleaning
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {services.map((service) => {
            // Commercial (id 4) and Hazardous (id 6) need custom quote
            const isContactService = service.id === 4 || service.id === 6;
            
            return (
              <div
                key={service.id}
                className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
              >
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                </div>
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-[#0B7CB5] transition-colors duration-200">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed mb-4">{service.description}</p>
                  <Button
                    onClick={() => scrollToContact(service.id)}
                    variant="ghost"
                    className="text-[#0B7CB5] hover:text-[#095a87] p-0 h-auto font-semibold group/btn"
                  >
                    {isContactService ? 'Get a Custom Quote' : 'Calculate Price'}
                    <ArrowRight className="ml-2 w-4 h-4 group-hover/btn:translate-x-1 transition-transform duration-200" />
                  </Button>
                </div>
              </div>
            );
          })}
        </div>

        <div className="text-center">
          <Button
            onClick={() => navigate('/calculator')}
            size="lg"
            className="bg-[#0B7CB5] hover:bg-[#095a87] text-white px-8 py-6 text-lg transition-all duration-200 hover:shadow-xl"
          >
            Get Your Free Estimate
          </Button>
        </div>
      </div>
    </section>
  );
};